import React from 'react';

export function PodcastBurntOutIcon({
  width = '100%',
}: {
  width?: string | number;
}) {
  return (
    <svg
      width={width}
      viewBox="0 0 347 330"
      xmlns="http://www.w3.org/2000/svg"
      fontFamily="Maax"
      style={{ userSelect: 'none' }}
      aria-label="An illustration of a baby bottle and a candle, with the caption: Three Kids + Candle-making = Burnt Out"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M233.86 96.82a17.73 17.73 0 100-35.46 17.73 17.73 0 000 35.46z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M263.01 295.42h-58.3a4.04 4.04 0 01-4.04-4.03s5.94-112.3 5.94-128.96c0-11.5-2.23-26.12-3.95-35.72a66.7 66.7 0 013.62-36.5c1.78-4.45 3.5-7.35 4.36-7.35h46.44c.83 0 2.43 2.96 4.12 7.35a70.43 70.43 0 013.53 37.77c-1.66 9.34-3.65 22.8-3.65 34.42 0 16.87 5.94 128.96 5.94 128.96a4 4 0 01-4 4.06z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M264.64 87.25h-61.56a4.33 4.33 0 010-8.66h61.56a4.33 4.33 0 010 8.66z"
          fill="#F66181"
          fillRule="nonzero"
        />
        <path
          d="M234.42 75.63h-1.1a5.13 5.13 0 01-5.13-5.13V50.13a5.13 5.13 0 015.14-5.13h1.1a5.13 5.13 0 015.12 5.13V70.5a5.15 5.15 0 01-5.13 5.13z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M213 328.84h-46.47a29.95 29.95 0 01-29.93-29.96V267.1a32.36 32.36 0 0132.35-32.34h42.85a29.95 29.95 0 0129.96 29.95v35.4a28.76 28.76 0 01-28.77 28.74z"
          fill="#E1A3FC"
          fillRule="nonzero"
        />
        <path
          d="M178.78 191.25a31.81 31.81 0 00-3.4 21.86c1.06 5.06 4.03 10.4 9.1 11.51 4.95 1.09 10.01-2.58 11.99-7.25 1.97-4.68 1.5-10.02.42-14.97-1.09-4.95-2.76-9.81-3.06-14.88-.31-4.67 2.61-11.76-4.51-7.4a31.34 31.34 0 00-10.54 11.13z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M196.08 218.26c-2-3.12-5.48-5.15-9.46-5.15a11.2 11.2 0 00-9.43 5.15c1.59 3.08 4 5.64 7.32 6.37 4.61 1 9.34-2.15 11.57-6.37z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M290.4 328.84c-31.11 0-56.54-25.45-56.54-56.52V183a4.43 4.43 0 014.42-4.42h104.25a4.43 4.43 0 014.42 4.42v89.33c0 31.07-25.46 56.52-56.56 56.52z"
          fill="#F66181"
          fillRule="nonzero"
        />
        <path
          d="M346.81 276.08c-1.33-.22-2.7-.4-4.06-.56-5.98-.7-12-.97-17.97-1.72-6.01-.78-12-2.09-17.5-4.68a40.1 40.1 0 01-7.8-4.83 25.36 25.36 0 01-7.5-9.68 39.48 39.48 0 01-2.79-8.74c-1.16-5.97-.97-12.1-.22-18.1.72-5.98 1.95-11.88 2.73-17.83.8-6 1.14-12.1.2-18.1a44.06 44.06 0 00-4.35-13.24h-49.27a4.43 4.43 0 00-4.42 4.42v61.07c3.7 1 7.48 1.65 11.3 2.09 5.98.7 11.98.97 17.97 1.72 6 .78 11.99 2.09 17.5 4.68a40.2 40.2 0 016.5 3.86 27.95 27.95 0 019.4 12.1 40.44 40.44 0 012.18 7.26c1.17 5.98.97 12.1.22 18.1-.72 5.98-1.95 11.88-2.73 17.83-.75 5.56-1.08 11.24-.38 16.83a56.74 56.74 0 0051-52.48z"
          fill="#E1A3FC"
          fillRule="nonzero"
        />
        <path
          d="M297.07 146.03a21.88 21.88 0 013 16.9c-.94 3.93-3.59 8.05-8.07 8.9-4.4.84-8.87-2-10.62-5.6-1.76-3.63-1.34-7.74-.37-11.58.98-3.84 2.45-7.6 2.73-11.51.28-3.62-2.3-9.1 3.98-5.73a26.11 26.11 0 019.35 8.62z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M281.74 166.92a10.4 10.4 0 018.37-3.98c3.5 0 6.6 1.59 8.38 3.98-1.4 2.39-3.54 4.36-6.49 4.92-4.11.78-8.29-1.64-10.26-4.92z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M241.76 300.54v-.53c-7.1 4.26-16.89-1.08-22.65-7.5-14.05-15.7-29.6-19.75-41.92.74-10.66 17.72-30.5-11.6-40.1 11.46a29.96 29.96 0 0029.47 24.56h46.46a28.72 28.72 0 0028.74-28.73z"
          fill="#F66181"
          fillRule="nonzero"
        />
        <text fontSize="20" fontWeight="bold" fill="#FFF">
          <tspan x="0" y="19">
            Three Kids +
          </tspan>
          <tspan x="0" y="49">
            Candle-making =
          </tspan>
        </text>
        <text fontSize="60" fontWeight="800" letterSpacing="-.7" fill="#E1A3FC">
          <tspan x="0" y="152">
            Burnt
          </tspan>
          <tspan x="0" y="212">
            Out
          </tspan>
        </text>
      </g>
    </svg>
  );
}
